import { Component, Inject, Output, EventEmitter, computed, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PushPreviewStore } from './push-preview-store.service';
import {PushPreviewCardComponent} from "./preview-card.component";
import {AppNotification, PUSH_PREVIEW_CONFIG, PushPreviewConfig} from "./notification-preview.config";

@Component({
    selector: 'app-push-preview-container',
    standalone: true,
    imports: [CommonModule, PushPreviewCardComponent],
    templateUrl: './preview-container.component.html',
    styleUrls: ['./preview-container.component.scss']
})
export class PushPreviewContainerComponent {
    @Output() openTray = new EventEmitter<void>();
    @Output() notificationClick = new EventEmitter<AppNotification>();

    isExpanded = signal(false);

    // --- COMPUTED LOGIC ---

    // 1. Decide which notifications to actually render in the HTML
    viewList = computed(() => {
        const all = this.store.notifications();

        // If expanded, show EVERYTHING
        if (this.isExpanded()) {
            return all;
        }

        // If collapsed, show only the Max allowed (e.g., 2)
        return all.slice(0, this.config.maxVisibleCollapsed);
    });

    // 2. Calculate the "Hidden" count for the button
    hiddenCount = computed(() => {
        const total = this.store.totalCount();
        const max = this.config.maxVisibleCollapsed;

        if (this.isExpanded()) return 0;
        return Math.max(0, total - max);
    });

    // 3. Auto-close settings
    shouldAutoClose = computed(() => {
        const expanded = this.isExpanded();
        if (!expanded) return this.config.autoCloseInCollapsed;
        return this.config.autoCloseInExpanded;
    });

    timeoutMs = computed(() => {
        return this.isExpanded()
            ? this.config.autoCloseTimeoutMsExpanded
            : this.config.autoCloseTimeoutMsCollapsed;
    });

    constructor(
        public store: PushPreviewStore,
        @Inject(PUSH_PREVIEW_CONFIG) public config: PushPreviewConfig
    ) {}

    onDismiss(id: string) {
        this.store.dismiss(id);

        // If we cleared everything, collapse automatically
        if (this.store.totalCount() === 0) {
            this.isExpanded.set(false);
        }
    }

    onDismissAll() {
        this.store.dismissAll();
        this.isExpanded.set(false);
    }

    onNotificationClick(note: AppNotification) {
        this.notificationClick.emit(note);
        this.store.dismiss(note.id);
    }

    onExpandClick() {
        this.isExpanded.set(true);
    }

    onViewAllClick() {
        this.openTray.emit();
    }

    onCollapseClick() {
        this.isExpanded.set(false);
    }
}